
$(function () {
    console.log('Player of Match script loaded');
//    console.log('user_logged native ready', user_logged);
    
//    if (typeof user_logged === 'undefined') {
//        var user_logged = 0;
//    }

    
    if (!$(".team-home").is(':visible') || !$(".team-away").is(':visible')) {

        $('.list-inline a:first').addClass('active');
    }

    $(".list-inline a").click(function () {
        console.log('Player of Match link clicked');
        var parent = $(this).closest('.player-widget-wrap');
        if (!$(this).hasClass('active')) {
            if (!parent.find(".team-home").is(':visible') || !parent.find(".team-away").is(':visible')) {
                parent.find('.team-player-item').toggleClass('hidden-mb');
                parent.find('.list-inline a').removeClass('active');
                $(this).toggleClass("active");
            }
        }
    });

    $('.player-poll li').on('change', function () {		
		var tournamentId = 0;
		if (typeof $(this).closest('.player-match').attr('data-tournamentid') !== 'undefined') {
			tournamentId = parseInt($(this).closest('.player-match').attr('data-tournamentid'));
		}
		if(tournamentId == 4103){	
			$('.player-poll li input[type="checkbox"]').each(function() {
				$(this).prop('checked', false);
			});
			$(this).find('input[type="checkbox"]').prop('checked', true);
			displayUserSidebar("worldcup_player_of_match");
		} else if(tournamentId == 4137) {	
			var playerId = ($(this).attr('data-player'));
            var moduleId = ($(this).closest('.player-match').attr('data-module'));
            processPlayerVote("/playermatch/" + moduleId, {'player_id': playerId}, displayResults, $(this).closest('.player-widget-wrap'), this)
		} else if (!user_logged) {
            console.log('user_logged = ', user_logged);
            // Uncheck all players before showing login dialog
            $('.player-poll li input[type="checkbox"]').each(function() {
                $(this).prop('checked', false);
            });
            displayUserSidebar('main-profile-menu');
        } else {
            var playerId = ($(this).attr('data-player'));
            var moduleId = ($(this).closest('.player-match').attr('data-module'));
            processPlayerVote("/playermatch/" + moduleId, {'player_id': playerId}, displayResults, $(this).closest('.player-widget-wrap'), this)
        }
    });	

    var processPlayerVote = function (url, data, callback, wrapper, initiator) {
        $.post(url, data, function (data) {
            callback(wrapper, initiator, data)
        }, 'json')
    };

function displayUserSidebar(idElement){
    $("#" + idElement).removeClass('hidden');
    $("#" + idElement + ':not(.hidden)')[0].showModal();
}

    var displayResults = function (wrapper, initiator, data) {
        wrapper.append(data['resultsModule']);
        wrapper.find('.player-match').remove();
        if(data['relatedArticles'].length > 0){
            wrapper.append(data['relatedArticles']);
        }
    };	
	
	$('body').on('click', '#game_submit_playerofmatch', function (e) {
		
        e.preventDefault();
        var flag = true,
                gameEmail = $('#game-email'),
                gameName = $('#game-name'),
				gameSurname = $('#game-surname'),
                gamePhone = $('#game-phone'),
                mailsCheck = $('#game-mails-checkbox'),
                termsCheck = $('#game-terms-checkbox');
	
		
		var moduleId = parseInt($('.player-poll').closest('.player-match').attr('data-module'));
		var playerId = parseInt($('[data-player] input:checked').closest('li').attr('data-player'));
		
		if (moduleId == 0) {
            flag = false;
        }
		if (playerId == 0) {
            flag = false;
        }
		
		if (gameEmail.val().length === 0) {
            gameEmail.addClass('error-field');
            gameEmail.next().removeClass('g-hidden');
            flag = false;
        }
        if (gameName.val().length === 0) {
            gameName.addClass('error-field');
            gameName.parent().children('.validation-error').removeClass('g-hidden');
            flag = false;
        }
		 if (gameSurname.val().length === 0) {
            gameSurname.addClass('error-field');
            gameSurname.parent().children('.validation-error').removeClass('g-hidden');
            flag = false;
        }
        if (gamePhone.val().length === 0) {
            gamePhone.addClass('error-field');
            gamePhone.parent().children('.validation-error').removeClass('g-hidden');
            flag = false;
        }		
        if (!(termsCheck.is(':checked'))) {
            termsCheck.parent().parent().children('.validation-error').removeClass('g-hidden');
            flag = false;
        }
		
		var receiveMails = 0;
		if (mailsCheck.is(':checked')) {
            receiveMails = 1;
        }
		
		if (flag) {
            $('#worldcup_player_of_match .error-field-noprediction').addClass('g-hidden');
            var email = gameEmail.val(),
                    name = gameName.val(),
					surname = gameSurname.val(),
					phone = gamePhone.val(),
                    mails_receive = receiveMails,                    
                    terms = termsCheck.is(':checked');
            gamePOMa(email, name, surname, phone, mails_receive, terms, moduleId, playerId);
        }		
	 });
	 
	 function gamePOMa(email, name, surname, phone, mails_receive, terms, moduleId, playerId) {		 
        $.ajax({
            type: "POST",
			url: '/worldcup2022/game/save_user_vote_player_of_match',
            crossDomain: true,
            dataType: "json",
            data: {
                userEmail: email,
                userName: name,
				userSurname: surname,
                userMailsReceive: mails_receive,
                userTerms: terms,
                userPhone: phone,
                gameModuleId: moduleId,
				gamePlayerId: playerId,
				gameDomainName: 'worldcup2022_playerofmatch'
            },
            success: function (response) {
                var data = response;
                if (data['success'] == 1) {
					location.reload();
                } else {
                    $('#worldcup_player_of_match .error-field-noprediction').text(data['msg']);
                    $('#worldcup_player_of_match .error-field-noprediction').removeClass('g-hidden');
                }
            }
        });
    }
	
	
});
